import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Buffer } from 'buffer';
import { Modal } from 'reactstrap';

import App from './App';

import './scss/bootstrap-scoped.scss'; // Scoped bootstrap, load first
import './scss/custom.scss'; // Custom bootstrap variables
import './main.css'; // Custom classes, load after bootstrap
import './index.css'; // Tailwind

// @ts-ignore
(window as any).Buffer = Buffer;

// @ts-ignore
Modal.defaultProps = {
  // @ts-ignore
  ...Modal.defaultProps,
  wrapClassName: 'use-bs', // To make sure the modal is styled with bootstrap
};

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // @ts-expect-error - BrowserRouter type doesn't have implicit children, will get fixed if we upgrade
  <BrowserRouter basename={baseUrl || undefined}>
    <App />
  </BrowserRouter>,
);
